// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"style_dashboard__gsopY","dashboardContent":"style_dashboardContent__1cnDR","dashboard_box_playerPainel":"style_dashboard_box_playerPainel__20_Zl"};